const { PAGE_TYPES, GA4 } = require('../../../../../config/analytics');

const ga4PageTypeByPageType = {
  [PAGE_TYPES.account]: GA4.PAGE_TYPES.account,
  [PAGE_TYPES.campaign]: GA4.PAGE_TYPES.campaign,
  [PAGE_TYPES.cart]: GA4.PAGE_TYPES.cart,
  [PAGE_TYPES.category]: GA4.PAGE_TYPES.category,
  [PAGE_TYPES.checkout]: GA4.PAGE_TYPES.checkout,
  [PAGE_TYPES.home]: GA4.PAGE_TYPES.home,
  [PAGE_TYPES.info]: GA4.PAGE_TYPES.info,
  [PAGE_TYPES.login]: GA4.PAGE_TYPES.login,
  [PAGE_TYPES.product]: GA4.PAGE_TYPES.product,
  [PAGE_TYPES.product_look]: GA4.PAGE_TYPES.product_look,
  [PAGE_TYPES.product_look_pdp]: GA4.PAGE_TYPES.product_look_pdp,
  [PAGE_TYPES.purchase]: GA4.PAGE_TYPES.purchase,
  [PAGE_TYPES.search]: GA4.PAGE_TYPES.search,
  [PAGE_TYPES.searchModal]: GA4.PAGE_TYPES.search,
};

/**
 * Parse to GA4's pageType format
 * @param {string} pageType Page type from analytics constant PAGE_TYPES
 * @returns {string} parsed page type
 */
function parseGa4PageType(pageType) {
  return ga4PageTypeByPageType[pageType];
}

module.exports = {
  parseGa4PageType,
};
